import { render, staticRenderFns } from "./ifirmfg.vue?vue&type=template&id=c44fb794&scoped=true&"
import script from "./ifirmfg.vue?vue&type=script&lang=js&"
export * from "./ifirmfg.vue?vue&type=script&lang=js&"
import style0 from "./ifirmfg.vue?vue&type=style&index=0&id=c44fb794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44fb794",
  null
  
)

export default component.exports